import script from "./AccueilPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AccueilPage.vue?vue&type=script&setup=true&lang=js"

import "./AccueilPage.vue?vue&type=style&index=0&id=1e76b724&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e76b724"]])

export default __exports__